import { AppState } from '..';
import { SET_COMPANIES_FIELD, FETCH_COMPANIES_SUCCESS, RESET_COMPANIES, FETCH_COMPANIES_REQUEST } from '../actions/companiesActions';
import { ICompanyPagination } from '../models/Company';
import { BillsbyAdminAction } from '../models/BillsbyAdminAction';

export interface ICompaniesReducerState {
  companiesPaginated: ICompanyPagination;
  searchedCompanies: string;
  hasCompanies: boolean;
  isLoading: boolean,
}

const initState = {
  companiesPaginated: {
    currentPage: 1,
    pageCount: 1,
    pageSize: 0,
    rowCount: 0,
    results: undefined
  },
  isLoading: true,
  searchedCompanies: '',
  hasCompanies: false
};

export default function companiesReducer(
  state: ICompaniesReducerState = initState,
  action: BillsbyAdminAction,
  store: AppState
) {
  switch (action.type) {
    case SET_COMPANIES_FIELD:
      return { ...state, [action.fieldName]: action.fieldValue };
    case FETCH_COMPANIES_REQUEST:
      return { ...state, isLoading: true };
    case FETCH_COMPANIES_SUCCESS:
      const hasCompanies = (!!action.response.results && action.response.results.length > 0) || state.hasCompanies;
      return { ...state, companiesPaginated: action.response, hasCompanies, isLoading: false };
    case RESET_COMPANIES:
      return { ...initState };
    default:
      return state;
  }
}
